import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import Session from '@nmx/utils/dist/utilities/frontend/session';
import styled, {
  css, ThemeContext, withTheme, useContext,
} from 'styled-components';
import Typography from '../../base/Typography';
import { Container, Row, Col } from '../../base/Grid';
import Button from '../../base/Button';
import Link from '../../base/Link';
import Icon from '../../base/Icon';
// import theme from '../../theme'

// styles
import {
  Banner, DismissButton, DataSeparator, DataTextContainer, StartAdornment, Styles,
} from './styles'; // TODO: move styles to Component
import './banner.scss';

import DynamicConfig from '../../utils/dynamicConfig';

export const BannerModule = ({
  'data-banner-id': bannerId = 'nmx-banner',
  'data-app-name': appName,
  'data-base-url': baseUrl,
  'data-static-config': staticConfig,
}) => {
  const [bannerConfig, setBannerConfig] = useState({});
  const [bannerDismissed, setBannerDismissed] = useState(false);
  const [drawerStatus, setDrawerStatus] = useState(false);
  const styles = Styles();

  // contstants
  const DEFAULT_BG_COLOR = '#F7FAFC';
  const DISMISSED_SESSION_KEY = `${appName}-dismiss-banner`;
  const DEFAULT_HIDE_DISMISS_BUTTON = false;

  useEffect(() => {
    if (staticConfig) {
      setBannerConfig(staticConfig.banner);
      return;
    }
    if (appName !== 'nmx-static'
      && appName !== 'nmx-static-fa-profile-pages'
      && appName !== 'nmx-static-articles') {
      return;
    }
    const dynamicConfigUrl = `${baseUrl}/assets/dynamic-config/${appName}.json`;
    const dynamicConfigSessionKey = `${appName}-dynamic-config`;
    DynamicConfig(dynamicConfigUrl, dynamicConfigSessionKey).then((dynamicConfig) => {
      setBannerConfig(dynamicConfig.banner);
      setBannerDismissed(Session.get(DISMISSED_SESSION_KEY));
    });
  }, []);

  const toggleDrawer = () => setDrawerStatus(!drawerStatus);

  function dismissBanner() {
    setBannerDismissed(true);
    Session.set(DISMISSED_SESSION_KEY, true);
  }

  return (
    (bannerConfig.isActive === true && !bannerDismissed) && (
      <Banner id={bannerId} className={`nmx-banner nmx-no-print ${bannerId}`} style={{ backgroundColor: bannerConfig.bgColor || DEFAULT_BG_COLOR }}>
        <Container styles={styles.Container}>
          {bannerConfig.variant === 'text-link' && (
            <Row>
              <Col nested>
                <Row>
                  <Col
                    styles={styles.ColInner(bannerConfig.startAdornment, bannerConfig.hideDismissButton || DEFAULT_HIDE_DISMISS_BUTTON)}
                  >
                    <DataTextContainer variant='text-link'>
                      {bannerConfig.startAdornment ? <StartAdornment styles={styles.StartAdornment}><Icon variant={bannerConfig.startAdornment} className="nmx-icon-start-adornment" width='18px' height='18px' style={{ verticalAlign: 'middle' }} /></StartAdornment> : null}
                      <Link
                        id={`${bannerId}-link-id`}
                        variant="secondary"
                        href={bannerConfig.data.ctaUrl}
                        aria-label={bannerConfig.data.ctaAriaLabel}
                      >
                        {bannerConfig.data.text}
                      </Link>
                    </DataTextContainer>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
          {bannerConfig.variant === 'cta-button' && (
            <Row>
              <Col nested>
                <Row>
                  <Col
                    className="nmx-align-center"
                    styles={styles.ColInner(bannerConfig.startAdornment, bannerConfig.hideDismissButton || DEFAULT_HIDE_DISMISS_BUTTON)}
                  >
                    <DataTextContainer>
                      {bannerConfig.startAdornment ? <StartAdornment styles={styles.StartAdornment}><Icon variant={bannerConfig.startAdornment} className="nmx-icon-start-adornment" width='18px' height='18px' style={{ verticalAlign: 'middle' }} /></StartAdornment> : null}
                      {
                        bannerConfig.data.text.length > 0
                        && bannerConfig.data.text.map((item, index) => (
                          <Fragment key={`${item}${index}`}>
                            {item}
                            {index < bannerConfig.data.text.length - 1 && <DataSeparator>&#124;</DataSeparator>}
                          </Fragment>
                        ))
                      }
                    </DataTextContainer>
                    <Button
                      id={`${bannerId}-cta-button-id`}
                      aria-label="Test Banner CTA Button"
                      variant="tertiary"
                      onClick={() => { window.location = bannerConfig.data.buttonCtaUrl; }}
                      styles={styles.CtaButton('cta-button')}
                    >
                      {bannerConfig.data.buttonCtaText}
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
          {bannerConfig.variant === 'drawer' && (
            <Row>
              <Col nested>
                <Row>
                  <Col
                    styles={styles.ColInner(bannerConfig.startAdornment, bannerConfig.hideDismissButton || DEFAULT_HIDE_DISMISS_BUTTON, 'drawer')}
                  >
                    <DataTextContainer variant='drawer'>
                      {bannerConfig.startAdornment ? <StartAdornment styles={styles.StartAdornment} variant='drawer'><Icon variant={bannerConfig.startAdornment} className="nmx-icon-start-adornment" width='18px' height='18px' style={{ verticalAlign: 'middle' }} /></StartAdornment> : null}
                      <Button
                        id={`${bannerId}-cta-expand-button-id`}
                        aria-label="Open Drawer for more information"
                        variant="quarternary"
                        onClick={toggleDrawer}
                        // onClick={() => toggleDrawer({ drawerStatus })}
                        styles={styles.CtaButton('quarternary')}
                      >
                        {bannerConfig.data.ctaText}
                        <Icon variant={drawerStatus ? 'drawer-caret-flipped' : 'drawer-caret'} />
                      </Button>
                    </DataTextContainer>
                  </Col>
                </Row>
                {drawerStatus && (
                  <Row>
                    <Col
                      styles={styles.ColDrawer()}
                      className='nmx-banner-drawer__drawer-contents'
                    >
                      <DataTextContainer variant='drawer-contents'>
                        {bannerConfig.data.drawerContents.text} <Link variant="secondary" href={bannerConfig.data.drawerContents.linkUrl}>{bannerConfig.data.drawerContents.linkText}</Link>
                      </DataTextContainer>
                    </Col>
                  </Row>
                )}

              </Col>
            </Row>
          )}
        </Container>
        {!bannerConfig.hideDismissButton && (
          <DismissButton onClick={dismissBanner} aria-label="Dismiss Banner" />
        )}
      </Banner>
    )
  );
};

BannerModule.propTypes = {
  'data-banner-id': PropTypes.string,
  'data-static-config': PropTypes.object,
  'data-app-name': PropTypes.string,
  'data-base-url': PropTypes.string,
};

export default withTheme(BannerModule);
